import service from './index';

export default {
  async getBrandByName (params) {
    const response = await service.get('/brands/filter', {
      params: {
        pageSize: 100,
        ...params,
      },
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
  async getBrandBySupplier (params) {
    const response = await service.get('/brands/by-supplier', {
      params,
      hideSpinner: true,
      hideErrorMessage: true,
    });
    return response;
  },
};
